const featureAnnouncementContent = (() => {
    try {
        return require.context('./content', false, /\.md$/);
    } catch (error) {
        return Object.assign(() => '', { keys: () => [] });
    }
})();

export default featureAnnouncementContent;
